<template>
  <div>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :loading="loading"
      :search="search"
      :items="items"
      :headers="headers"
    >
      <template v-slot:[`item.id`]="{ item }">
        {{ item.std_id }}
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-btn @click="showDialog(item)" small>
          <!-- <v-icon dark>mdi-plus</v-icon> -->
          Add Details
        </v-btn>
        <v-btn
          v-if="item.user_id == '0'"
          color="green"
          @click="showDialog2(item)"
          small
        >
          <!-- <v-icon dark>mdi-plus</v-icon> -->
          Set Username
        </v-btn>
      </template>
      <template v-slot:[`item.delete`]="{ item }">
        <router-link
          class="profile-link"
          active-class
          :exact="true"
          :to="{ name: 'EditJoinedStudent', params: { id: item.std_id } }"
        >
          <v-icon color="success">mdi-file-edit</v-icon>
        </router-link>
        <v-icon color="red" @click="confirmDelete(item)">mdi-delete</v-icon>
      </template>
      <template v-slot:[`item.student`]="{ item }">
        <!-- <span>{{ item.student.std_fname }} {{ item.student.std_lname }}</span> -->
        <span>{{ (item.student) ? item.student.std_fname +' '+item.student.std_lname : 'Student Not Found' }}</span>
      </template>

      <template v-slot:[`item.id`]="{ item }">
        <span>{{ item.work_sheets ? item.work_sheets.work_sheet_code : 'Not Found' }}
          </span
        >
      </template>

      <template v-slot:[`item.work_sheet`]="{ item }">
        <v-btn text color="primary">
          <!--          <router-link-->
          <!--            class="profile-link"-->
          <!--            active-class="active"-->
          <!--            :exact="true"-->
          <!--            :to="{name: 'StudentProfile'}"-->
          <!--          >{{item.name}}</router-link>-->
          <a
            class="profile-link word"
            active-class="active"
            :exact="true"
            :href="`https://view.officeapps.live.com/op/view.aspx?src=${getBaseURL}/storage/${item.work_sheet}`"
           target="_blank"
          
          >
            <span class="table-tutor-name">view</span>
            <!-- <span class="table-tutor-email">{{item.tutor_email}}</span> -->
          </a>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" persistent max-width="600px"> </v-dialog>

    <v-overlay :value="overlay" style="z-index: 99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <delete-dialog
      @success="deleteGroup"
      :confirm-loading="deleteConfirmLoading"
      @closeDialog="cancelDelete"
      :dialog="delete_dialog"
      title="Group"
    ></delete-dialog>
  </div>
</template>

<script>
// import DiscountDialog from "./DiscountDialog";
// import TutorAssignmentForm from "./TutorAssignmentForm";
import DataTableMixin from "../../mixins/dataTable";
import Form from "../../utils/form";
import DeleteDialog from "../Dialogs/DeleteDialog";
import DeleteRow from "../../mixins/deleteRow";
import { bus } from '../../main';
export default {
  name: "AssignedWorkSheet",
  components: {
    DeleteDialog,
  },
  mixins: [DataTableMixin, DeleteRow],
  data() {
    return {
      dialog: false,
      search: null,
      overlay: false,
      errors: {},
      url: process.env.VUE_APP_BASE_URL,
      dialog: false,

      currentRow: 0,
      loading: true,
      page: 1,
      pageCount: 3,
      itemsPerPage: 10,
      headers: [
        // { text: "SRNO", sortable: true, value: "id" },
        {
          text: "Code",
          sortable: true,
          value: "id",
        },
        {
          text: "Work Sheet",
          value: "work_sheet",
          sortable: true,
        },
        {
          text: "Student Name",
          value: "student",
          sortable: true,
        },
            {
          text: "Tutor Name",
          value: "tutor.full_name",
          sortable: true,
        },
        {
          text: "Class",
          value: "work_sheets.class.class_name",
          sortable: true,
        },
        {
          text: "Subject",
          value: "subject_name",
          sortable: true,
        },
        {
          text: "Month",
          value: "month",
          sortable: true,
        },
        {
          text: "Week",
          value: "week",
          sortable: true,
        },
        {
          text: "Version",
          value: "work_sheets.version",
          sortable: true,
        },

        // {
        //   text: "Action",
        //   value: "delete",
        //   sortable: true,
        // },
      ],
    };
  },
  computed: {
    getBaseURL(url) {
      return window.baseURL;
    },
  },
  methods: {
    // myFunction: function(item) {
    // var myWindow =  window.open( 
    //     `https://view.officeapps.live.com/op/view.aspx?src=${this.url}/storage/${item.work_sheet}`, '_new','noopener');
     
    //  myWindow.focus(); 
         
    // },
    month(month) {
      let data = [];
      data["September"] = 1;
      data["October"] = 2;
      data["November"] = 3;
      data["December"] = 4;
      data["January"] = 5;
      data["February"] = 6;
      data["March"] = 7;
      data["April"] = 8;
      data["May"] = 9;
      data["June"] = 10;
      data["July"] = 11;
      data["August"] = 12;

      return data[month];
    },
    deleteGroup() {
      // console.log(this.current_row);
      axios
        .get("/joined/students/remove/" + this.current_row.std_id)
        .then((response) => {
          // this.getItems()
          this.deleteConfirmLoading = false;
          this.delete_dialog = false;
          this.getItems();
        })
        .catch((error) => {
          this.deleteConfirmLoading = false;
          this.delete_dialog = false;
          // Toast.fire({
          //     icon: 'error',
          //     title: 'Cannot Deleted Linked Groups!',
          // })
        });
    },
    cancelDelete() {
      this.deleteConfirmLoading = false;
      this.delete_dialog = false;
    },

    showDialog(item) {
      console.log(item);
      this.dialog = true;
      axios.get("classes").then((response) => {
        // this.formalizeTable(response.data);
        // this.loading = false;
        console.log(response);
        this.classes = response.data.response;
        this.data.student_id = item.std_id;
        this.data.joining_date = item.std_joining_date;
        this.data.ending_date = item.std_leaving_date;
        this.data.date_of_birth = item.std_dob;
        this.data.number_of_hours = item.std_no_of_hours;
        this.data.selected_class = parseInt(item.class_id);
      });
    },
    getItems() {
      axios.get(apiRoutes.WorkSheet.assignedWorkSheet).then((response) => {
        // this.formalizeTable(response.data);
        this.items = response.data.response;
        this.loading = false;
      });
    },
  },
  mounted() {
    this.getItems();
  },
  created(){
      bus.$on('workSheetPrint', (data) => {
     this.getItems();
    })
  }
};
</script>

<style scoped>
.ndfHFb-c4YZDc-Wrql6b {
  background-color: rgb(207, 43, 43) !important;
}
</style>
